import { FC } from 'react';
import { Text } from '@qga/roo-ui/components';

const SubText: FC = ({ children }) => (
  <Text display={['none', 'block']} as="div" lineHeight="normal" fontSize="base" mb={0}>
    {children}
  </Text>
);

export default SubText;
